import { history } from "instantsearch.js/es/lib/routers";

import { CONTENT_TYPES, INDEX_CONTENT } from "../../../search/algolia-indexes";

export const AlgoliaRouting = {
    router: history(),
    stateMapping: {
        stateToRoute(uiState: unknown) {
            const indexUiState = uiState[INDEX_CONTENT];
            const refinements = indexUiState?.refinementList;
            const refinementData = {};
            if (refinements) {
                const filters = Object.keys(refinements);
                filters.forEach((filterKey: string) => {
                    refinementData[filterKey] = indexUiState?.refinementList[filterKey];
                });
            }
            return {
                q: indexUiState.query,
                ...refinementData,
            };
        },
        routeToState(routeState) {
            const refinementList = {};
            const filters = Object.keys(routeState);
            filters.forEach((filterKey: string) => {
                refinementList[filterKey] = routeState[filterKey];
            });

            return {
                [INDEX_CONTENT]: {
                    query: routeState.q,
                    filters: `content_type:'${CONTENT_TYPES.RECIPE}'`,
                    refinementList: { ...refinementList },
                },
            };
        },
    },
};

export default AlgoliaRouting;
